"use client";

import { Typography } from "@tosize/ui";
import { useFormContext } from "react-hook-form";
import {
	getGroupedProductData,
	getSimpleProductData,
} from "~/app/[lang]/command/dialogs/import/actions";
import type { ListImportFormType } from "~/app/[lang]/command/dialogs/import/schema";

interface ImportDialogTitleProps {
	apiUrl: string;
	groupedId: string;
	messages: {
		import: string;
		fallback: string;
	};
}

export function ImportDialogTitle({ apiUrl, groupedId, messages }: ImportDialogTitleProps) {
	const { watch } = useFormContext<ListImportFormType>();

	const groupedProductId = watch("grouped_product_id");
	const simpleProductId = watch("simple_product_id");

	const { products } = getGroupedProductData({ id: groupedId });
	const { currentProduct } = getSimpleProductData({ apiUrl, groupedProductId, simpleProductId });

	const currentProductName =
		currentProduct?.product_name ?? products?.find((item) => item.id === groupedProductId)?.name;

	return (
		<div className="pt-4">
			<Typography className="font-bold font-primary text-lg">
				{currentProductName ? `${messages.import} ${currentProductName}` : messages.fallback}
			</Typography>
		</div>
	);
}
